import services from './../../services/service'; // Service Class
import validator from './../../services/validator'; // Validator
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import HorizontalWidget from '../HorizontalWidget.vue'; // HorizontalWidget
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; //Search Bar

let service = new services();
let valid = new validator();

export default {
    name: 'FindCnpro',
    data () {
        return {
            user: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            backgroundSize: 'contain',
            search_mode:false,
            cnproParentCategories:{},
            sub_categories: {},
            disable_btn: false,
            error_count: 0,
            request_sent: false,
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'horizontal-widget': HorizontalWidget,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);

                        //quickly check if premuim user
                        this.checkPremuimMember();
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
       
        checkPremuimMember(){
            //special case for profile
            service.getUser(this, this.user.user_id).then(data => {
                if(data.body.status == 200) {
                    this.user = data.body.data;
                    if(this.user.user_premuim_plan_id == 1){
                        this.$router.push("pricing");
                    }else{
                        this.getCnproParentCategories();
                    }
                }
            }).catch((err) => {
                if(err) {
                  //console.log(err)
                }
            })
            //../special case for profile
        },

        getCnproParentCategories() {
            service.getCnproParentCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.cnproParentCategories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        //cnpro sub categories
        getCnproSubCategories(parent){
            service.getCnproCategories(this,parent).then(data => {
                if(data.body.status == 200) {
                    this.sub_categories = data.body.data;
                   // document.getElementById("loader").style.visibility = "hidden";
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        prep_sub_categories(parent){
            this.search.type = 'cnpro-search';
            this.getCnproSubCategories(parent)
        },

        processForm(){
            this.disable_btn = true;
            this.error_count = 0; 
            var credentials = {
                request_area: this.search.area,
                request_user: this.user.user_id,
                request_phone: this.search.phone,
                request_work_address: this.search.work_address,
                request_work_date: this.search.work_date,
                request_details: this.search.details,
            }

            let navi = this.$router;
            //phone
            if(credentials.request_phone){
                if(!(valid.validatePhoneNumber(credentials.request_phone))){
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }
            }else{
                toastr.warning("Kindly fill in Phone Number", 'Missing Fields');
                this.disable_btn = false;
            }
            if(this.error_count == 0){
                if(this.search.details != null && this.search.area != null && this.search.phone != null){
                    service.findCnpro(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            toastr.success("Request Sent", 'We will get back to you!');
                            this.search = {}
                            this.request_sent = true;
                        }
                    }).catch((err) => {this.disable_btn = false; this.search = {}})
                }else{
                    toastr.warning("Kindly fill in fields with *", 'Missing Fields');
                    this.disable_btn = false;
                }
            }
            
        },
       
        //--//cnpros
        
        makeAnotherRequest(){
            this.request_sent = false;
        }
       
    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","help-me-find-a-cnpro");//log current page
            this.preset();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/FindCnpro/script.js